class ProviderResourcesPermissionChecker {
  hasPermission(currentUser, path) {
    if (!currentUser) {
      return false;
    }

    let { affiliationCd, typeCd: userTypeCd } = currentUser;
    let isAllowed = false;

    if (
      userTypeCd === "IRAD" ||
      userTypeCd === "ISAD" ||
      userTypeCd === "PRAD" || 
      userTypeCd === "PRUS"
    ) {
      isAllowed = true;
    }

    return isAllowed;
  }
}

export default new ProviderResourcesPermissionChecker();
